import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { notificationSettingsPageQueryOptions } from "~/app/api/pageData/notificationSettingsPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createNotificationSettingsPage } from "~/features/notifications/NotificationSettingsPage/NotificationSettingsPage";

function NotificationSettingsRoute() {
  const result = useLoaderData({
    from: "/notifications/settings",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createNotificationSettingsPage()}
    </StorefrontShellFrame>
  );
}

export async function loadNotificationSettingsPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(notificationSettingsPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const notificationSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/notifications/settings",
  loader: async ({ context }) => loadNotificationSettingsPageData(context),
  component: NotificationSettingsRoute,
});
